import React from "react";
import QRCode from "react-qr-code";
import { generateQRStringFromOrder } from "../../../utils/nbsQRGenerator";
import { isVolunteerDelivery } from "../../../utils/deliveryType";

interface NBSQRCodeProps {
  order: any;
  size?: number; // Optional QR code size (defaults to 120)
}

const NBSQRCode: React.FC<NBSQRCodeProps> = ({ order, size = 120 }) => {
  const { qrString, validation } = generateQRStringFromOrder(order);

  const showQR = order.userDeliveryResponse && isVolunteerDelivery(order);

  if (!showQR) {
    return (
      <div style={{ fontSize: "10px", color: "#999" }}>QR nije dostupan</div>
    );
  }

  // Show errors with small, simple text
  if (!validation.canGenerateQR) {
    return (
      <div style={{ fontSize: "10px", color: "#999" }}>
        QR greška
        {validation.errors.map((error, index) => (
          <div key={index}>{error}</div>
        ))}
      </div>
    );
  }

  // Simple: just return the QR code, no wrapper
  return <QRCode value={qrString!} size={size} level="L" />;
};

export default NBSQRCode;
